import { NxSpinnerModule } from "@allianz/ng-aquila/spinner";
import { CommonModule } from "@angular/common";
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  computed,
  DestroyRef,
  ElementRef,
  inject,
  viewChild,
} from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { TranslateModule } from "@ngx-translate/core";
import { createNotifier } from "ngxtension/create-notifier";
import { PolicyType } from "../shared/enums/policy-type.enum";
import { LoaderService } from "../shared/services/loader.service";
import { PolicyStore } from "../shared/store/policy.store";
import { createResizeObservable } from "../shared/utils/create-resize-observable.util";
import { MessageComponent } from "./ui/message/message.component";
import { NavigationButtonsComponent } from "./ui/navigation-buttons/navigation-buttons.component";
import { AppHeaderComponent } from "./ui/app-header/app-header.component";
import { environment } from "../environments/environment";
import { AppType } from "../shared/enums/app-type.enum";

@Component({
  selector: "app-core",
  imports: [NxSpinnerModule, TranslateModule, MessageComponent, CommonModule, NavigationButtonsComponent, AppHeaderComponent],
  templateUrl: "./core.component.html",
  styleUrl: "./core.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CoreComponent implements AfterViewInit {
  readonly AppType = AppType;
  private readonly loaderService = inject(LoaderService);
  private readonly destroyRef = inject(DestroyRef);
  private readonly containerWidthChangeNotifier = createNotifier();
  readonly policyStore = inject(PolicyStore);
  readonly appType = environment.appType;

  container = viewChild<ElementRef>("container");

  containerWidth = computed(() => {
    this.containerWidthChangeNotifier.listen();
    return this.container()?.nativeElement.clientWidth;
  });
  isLoader = computed(() => this.loaderService.isLoader());
  currentPolicyType = computed(() => this.policyStore.currentPolicyType$());
  isHeaderTitle = computed(
    () =>
      this.currentPolicyType() === PolicyType.MyHealth ||
      this.currentPolicyType() === PolicyType.MyHome,
  );

  ngAfterViewInit() {
    createResizeObservable(this.container()?.nativeElement)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((rect) => {
        this.containerWidthChangeNotifier.notify();
      });
  }
}
